import React, { useState } from "react";
import MarketingDocGate from "../MarketingDocGate";
import OpenAiConfiguration from "./OpenAiConfiguration";

import {
  PageHeader
} from "../components/Shared";


const integrations = [

  {
    name: "Google Analytics",
    description:
      "Track visitor events and conversions",
    icon: "bi-bar-chart-line",
    status: "Connected"
  },

  {
    name: "HubSpot",
    description:
      "Sync leads and contact activity",
    icon: "bi-arrow-repeat",
    status: "Available"
  },

  {
    name: "Slack",
    description:
      "Send team notifications",
    icon: "bi-slack",
    status: "Available"
  },

  {
    name: "Webhook",
    description:
      "Send events to your backend",
    icon: "bi-code-slash",
    status: "Available"
  }

];


function Integrations({ initial = {}, onSave }) {
  const [statuses, setStatuses] = useState(() => ({ ...Object.fromEntries(integrations.map((item) => [item.name, item.status])), ...(initial.statuses || {}) }));
  const [notice, setNotice] = useState("");
  const toggleConnection = async (integration) => {
    const current = statuses[integration.name];
    const next = current === "Connected" ? "Available" : "Connected";
    const updated = { ...statuses, [integration.name]: next };
    try {
      await onSave({ statuses: updated });
      setStatuses(updated);
      setNotice(`${integration.name} ${next === "Connected" ? "connected in demo mode" : "disconnected in demo mode"}.`);
    } catch (error) {
      setNotice(error.message || "Unable to update the integration.");
    }
  };

  return (
    <>

      <PageHeader
        eyebrow="TEAM & INTEGRATIONS"
        title="Integrations"
        description="Connect ChatBizz with the tools your team already uses."
      />


      {notice && <div className="alert alert-info py-2" role="status">{notice} Production OAuth/API credentials are not configured.</div>}
      <OpenAiConfiguration />
      <div className="integration-grid">

        {integrations.map(
          (integration) => (

            <div
              className="integration-card"
              key={integration.name}
            >

              <div className="integration-icon">

                <i
                  className={`bi ${integration.icon}`}
                ></i>

              </div>


              <div className="flex-grow-1">

                <h3>
                  {integration.name}
                </h3>

                <p>
                  {integration.description}
                </p>

              </div>


              <button
                className={`btn ${statuses[integration.name] === "Connected" ? "btn-light" : "btn-dark"} btn-sm`}
                type="button"
                onClick={() => toggleConnection(integration)}
              >

                {statuses[integration.name] === "Connected" ? "Disconnect" : "Connect"}

              </button>


              {statuses[integration.name] === "Connected" && (

                <span className="connected-dot"></span>

              )}

            </div>

          )
        )}

      </div>

    </>
  );
}

export default function IntegrationsPage() {
  return <MarketingDocGate section="integrations">{({ doc, save }) => <Integrations initial={doc} onSave={save} />}</MarketingDocGate>;
}
